<template>
  <main className="py-5 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-screen">
    <PageHeader title="Popups" subtitle="Beheer popups" route="/leaders/new" />

    <div class="bg-white shadow overflow-hidden sm:rounded-md">
      
      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Titel
                    </th>
                    <th scope="col" class="relative px-6 py-3">
                      Published
                    </th>
                    <th scope="col" class="relative px-6 py-3">
                      Edit
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="c in content" :key="c.id">
                    <td class="px-6 py-4 whitespace-nowrap">
                      <div class="flex items-center">
                        <div class="ml-4">
                          <div class="text-sm font-medium text-gray-900">
                            {{c.title}}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      {{c.published}}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <router-link :to="'/leaders/'+c.id" class="text-orange-600 hover:text-orange-900">edit</router-link>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>

    <Pagination v-if="content.length > 0" :page="page" :pages="pages" :itemCount="itemCount" :pageSize="pageSize" @next="next" @previous="previous" />

  </main>
</template>

<script>
import LeaderService from '../../../services/admin/leaders/service';

export default {
  name: 'Leader',
  data() {
    return {
      content: '',
      page: 1,
      pages: 0,
      itemCount: 0,
      pageSize: 8
    };
  },
  methods: {
    fetchData() {
      LeaderService.getItems(this.page, this.pageSize, this.searchQuery).then(
        response => {
          this.content = response.data.items;
          this.pages = response.data.pageCount;
          this.itemCount = response.data.itemCount
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    reset() {
      this.pages = 0;
      this.itemCount = 0;
    },
    clear() {
      this.searchQuery = null;
      this.reset();
      this.fetchData();
    },
    search() {
      this.reset();
      this.fetchData();
    },
    next() {
      this.page = this.page + 1;
      this.fetchData();
    },
    previous() {
      this.page = this.page - 1;
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
